"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWriteObligationValue = exports.roleToRoleKey = exports.highestRoleValue = exports.toRoleValue = exports.isRoleValue = void 0;
var types_1 = require("./types");
exports.isRoleValue = function (value) {
    return typeof value === "string" && types_1.roleValues.includes(value);
};
/** Cast to `RoleValue`; an empty string is equivalent to `ROLE_ANONYMOUS` */
exports.toRoleValue = function (value) {
    var strValue = String(value);
    if (strValue === "") {
        return "ROLE_ANONYMOUS";
    }
    return exports.isRoleValue(strValue) ? strValue : null;
};
var roleValueSortFn = function (a, b) {
    return types_1.roleValues.indexOf(a) - types_1.roleValues.indexOf(b);
};
exports.highestRoleValue = function (roles) {
    if (roles == null || roles.length === 0) {
        return null;
    }
    var sorted = roles.sort(roleValueSortFn);
    return sorted[sorted.length - 1];
};
var roleToRoleKeyMap = {
    ROLE_ANONYMOUS: "guest",
    ROLE_USER: "user",
    ROLE_EDITOR: "editor",
    ROLE_ADMIN: "admin"
};
/** Map role values from the application and ownership status to role keys in the definition source file */
exports.roleToRoleKey = function (role, isOwner) {
    // Use ownership only for ROLE_USER
    if (isOwner && role === "ROLE_USER") {
        return "owner";
    }
    return roleToRoleKeyMap[role];
};
exports.isWriteObligationValue = function (value) {
    return typeof value === "string" && types_1.writeObligationValues.includes(value);
};
